import React from 'react';
import { Card } from './ui/card';
import { mockBenefits } from '../utils/mock';
import { Award, Scale, TrendingUp, CheckCircle, ShieldCheck, Globe } from 'lucide-react';

const iconMap = {
  Award: Award,
  Scale: Scale,
  TrendingUp: TrendingUp,
  CheckCircle: CheckCircle,
  ShieldCheck: ShieldCheck,
  Globe: Globe
};

export const BenefitsSection = () => {
  return (
    <section className="py-20 bg-[#FFF7ED]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#7C2D12] mb-4">
              Benefits of Trademark Registration
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Federal trademark registration provides powerful legal protections and business advantages that go far beyond simple brand recognition.
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {mockBenefits.map((benefit, index) => {
              const IconComponent = iconMap[benefit.icon];
              
              return (
                <Card 
                  key={index}
                  className="p-8 bg-white border-2 border-[#FED7AA] hover:border-[#F97316] transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                >
                  <div className="bg-gradient-to-br from-[#7C2D12] to-[#F97316] w-16 h-16 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                    <IconComponent className="text-white" size={32} />
                  </div>
                  
                  <h3 className="text-xl font-bold text-[#7C2D12] mb-4">
                    {benefit.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </Card>
              );
            })}
          </div>

          {/* Call-out Box */}
          <div className="mt-16">
            <Card className="p-10 bg-gradient-to-r from-[#7C2D12] to-[#F97316] border-0">
              <div className="max-w-5xl mx-auto">
                <h3 className="text-4xl font-bold text-white mb-6 text-center">
                  Invest in Your Brand's Future Today
                </h3>
                <div className="space-y-4 text-white/95 text-lg leading-relaxed">
                  <p>
                    Trademark registration is one of the most valuable investments you can make in your business's long-term success. Unlike most business expenses that depreciate over time, your trademark actually increases in value as your brand recognition grows, your customer base expands, and your business reputation strengthens. Many successful companies find that their trademark portfolio becomes their single most valuable asset—worth more than real estate, equipment, inventory, and other tangible property combined.
                  </p>
                  <p>
                    Beyond monetary value, trademark protection provides invaluable peace of mind. You can invest in marketing, advertising, and brand building without fear that a competitor will copy your identity or force you to rebrand after you've built recognition. You can expand into new markets confident that your brand is already protected. You can negotiate business deals, attract investors, and pursue financing with the credibility that comes from professionally protected intellectual property.
                  </p>
                  <p className="font-semibold text-[#FED7AA] text-xl">
                    Don't leave your brand vulnerable to infringement, imitation, or theft. The cost of not protecting your trademark—including potential rebranding expenses, lost customer goodwill, and diminished market position—far exceeds the modest investment in federal registration. Protect what you've built. Secure your trademark today and ensure your brand remains exclusively yours for decades to come.
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
